export default __webpack_public_path__ + "static/media/wallet_banner_phone_image.4bd6430d.svg";